// extracted by mini-css-extract-plugin
module.exports = {"main":"Index_main__0G6GN"};